"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFeather = require("react-feather");

var _components = require("../components");

var _Layout = require("./Layout.style");

var NavbarSearch = function NavbarSearch(_ref) {
  var setNavbarSearch = _ref.setNavbarSearch,
      searchData = _ref.searchData,
      toggle = _ref.toggle;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Layout.NavbarSearchWrapper, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "search-input-icon"
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.Search, null)), /*#__PURE__*/_react.default.createElement(_components.AutoComplete, {
    searchData: searchData,
    setNavbarSearch: setNavbarSearch,
    toggle: toggle
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "search-input-close"
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.X, {
    onClick: function onClick() {
      return setNavbarSearch(false);
    }
  }))));
};

var _default = NavbarSearch;
exports.default = _default;